export const ENVIRONMENT = {
  name: 'prod',
  apiHkcApiName: 'prod',
  apiHkcInsightsName: 'prod',
  isProduction: true,
  fullName: 'Production',
  color: '#22c55e',
  appName: 'Insight Engine UI',
  oktaGroups: {
    campaign_manager: 'LCM-Insight_Engine-Prod_Campaign_Manager',
    qa: 'LCM-Insight_Engine-Prod_QA_Tester',
    promoter: '',
    drb_user: 'LCM-Insight_Engine-DRB_User',
    drb_manager: 'LCM-Insight_Engine-DRB_Manager'
  },
  bundleNames: ['marketing', 'marketing_translations']
};

export const CONFIG = {
  aws_project_region: 'us-east-1',
  aws_cognito_region: 'us-east-1',
  aws_user_pools_id: 'us-east-1_QIZstSrCm',
  aws_user_pools_web_client_id: '5jgt63ao17539q0rlkbgd82k3s',
  aws_cognito_identity_pool_id: 'us-east-1:a22feafb-d234-4798-b3b3-134f39deb6e5',
  API: {
    endpoints: [
      {
        name: 'campaigns_api',
        host: '37w7ggv8pa.execute-api.us-east-1.amazonaws.com',
        endpoint: 'https://37w7ggv8pa.execute-api.us-east-1.amazonaws.com',
        path: '/{stage}/campaigns',
        protocol: 'https',
        methods: ['GET', 'POST', 'DELETE'],
        url: 'https://37w7ggv8pa.execute-api.us-east-1.amazonaws.com/{stage}/campaigns'
      },
      {
        name: 'cleaning_estimates_api',
        host: '2vyeebb0i7.execute-api.us-east-1.amazonaws.com',
        endpoint: 'https://2vyeebb0i7.execute-api.us-east-1.amazonaws.com',
        path: '/{stage}/insights/qa/cleaning-estimates',
        protocol: 'https',
        methods: ['POST'],
        url: 'https://2vyeebb0i7.execute-api.us-east-1.amazonaws.com/{stage}/insights/qa/cleaning-estimates'
      },
      {
        name: 'robots_api',
        host: '2vyeebb0i7.execute-api.us-east-1.amazonaws.com',
        endpoint: 'https://2vyeebb0i7.execute-api.us-east-1.amazonaws.com',
        path: '/{stage}/insights/qa/robots',
        protocol: 'https',
        methods: ['GET', 'POST', 'DELETE'],
        url: 'https://2vyeebb0i7.execute-api.us-east-1.amazonaws.com/{stage}/insights/qa/robots'
      },
      {
        name: 'kozr_api',
        host: '2vyeebb0i7.execute-api.us-east-1.amazonaws.com',
        endpoint: 'https://2vyeebb0i7.execute-api.us-east-1.amazonaws.com',
        path: '/{stage}/insights/qa/canned-kozrs',
        protocol: 'https',
        methods: ['GET', 'POST', 'DELETE'],
        url: 'https://2vyeebb0i7.execute-api.us-east-1.amazonaws.com/{stage}/insights/qa/canned-kozrs'
      },
      {
        name: 'notifications_api',
        host: '2vyeebb0i7.execute-api.us-east-1.amazonaws.com',
        endpoint: 'https://2vyeebb0i7.execute-api.us-east-1.amazonaws.com',
        path: '/{stage}/campaigns/qa/notifications',
        protocol: 'https',
        methods: ['POST'],
        url: 'https://2vyeebb0i7.execute-api.us-east-1.amazonaws.com/{stage}/campaigns/qa/notifications'
      },
      {
        name: 'submissions_api',
        host: '2vyeebb0i7.execute-api.us-east-1.amazonaws.com',
        endpoint: 'https://2vyeebb0i7.execute-api.us-east-1.amazonaws.com',
        path: '/{stage}/campaigns/qa/notifications/submissions',
        protocol: 'https',
        methods: ['GET', 'POST'],
        url: 'https://2vyeebb0i7.execute-api.us-east-1.amazonaws.com/{stage}/campaigns/qa/notifications/submissions'
      },
      {
        name: 'high_traffic_area_api',
        host: '2vyeebb0i7.execute-api.us-east-1.amazonaws.com',
        endpoint: 'https://2vyeebb0i7.execute-api.us-east-1.amazonaws.com',
        path: '/{stage}/insights/qa/htars',
        protocol: 'https',
        methods: ['GET', 'POST'],
        url: 'https://2vyeebb0i7.execute-api.us-east-1.amazonaws.com/{stage}/insights/qa/htars'
      },
      {
        name: 'timeline_notifications_api',
        host: 'test-circuit-auth.test.iot.irobotapi.com',
        endpoint: 'https://test-circuit-auth.test.iot.irobotapi.com',
        path: '/circuit/robot/{robotid}/timeline/hkc',
        protocol: 'https',
        methods: ['GET'],
        url: 'https://test-circuit-auth.test.iot.irobotapi.com/circuit/robot/{robotid}/timeline/hkc'
      },
      {
        name: 'insights_api',
        host: 'dcxyzyg96j.execute-api.us-east-1.amazonaws.com',
        endpoint: 'https://dcxyzyg96j.execute-api.us-east-1.amazonaws.com',
        path: '/{stage}/registrations',
        protocol: 'https',
        methods: ['GET', 'POST', 'DELETE'],
        url: 'https://dcxyzyg96j.execute-api.us-east-1.amazonaws.com/{stage}/registrations'
      },
      {
        name: 'content_api',
        host: '1l7pep0br4.execute-api.us-east-1.amazonaws.com',
        endpoint: 'https://1l7pep0br4.execute-api.us-east-1.amazonaws.com',
        path: '/{stage}/content',
        protocol: 'https',
        methods: ['GET', 'POST', 'PUT'],
        url: 'https://1l7pep0br4.execute-api.us-east-1.amazonaws.com/{stage}/content'
      },
      {
        name: 'single_content_api',
        host: '1l7pep0br4.execute-api.us-east-1.amazonaws.com',
        endpoint: 'https://1l7pep0br4.execute-api.us-east-1.amazonaws.com',
        path: '/{stage}/content/{contentKey}',
        protocol: 'https',
        methods: ['GET', 'POST', 'DELETE'],
        url: 'https://1l7pep0br4.execute-api.us-east-1.amazonaws.com/{stage}/content/{contentKey}'
      },
      {
        name: 'content_templates_api',
        host: '1l7pep0br4.execute-api.us-east-1.amazonaws.com',
        endpoint: 'https://1l7pep0br4.execute-api.us-east-1.amazonaws.com',
        path: '/{stage}/content/templates',
        protocol: 'https',
        methods: ['GET', 'POST', 'DELETE'],
        url: 'https://1l7pep0br4.execute-api.us-east-1.amazonaws.com/{stage}/content/templates'
      },
      {
        name: 'template_preview_api',
        host: '2vyeebb0i7.execute-api.us-east-1.amazonaws.com',
        endpoint: 'https://2vyeebb0i7.execute-api.us-east-1.amazonaws.com',
        path: '/{stage}/template-preview',
        protocol: 'https',
        methods: ['POST'],
        url: 'https://2vyeebb0i7.execute-api.us-east-1.amazonaws.com/{stage}/template-preview'
      },
      {
        name: 'surveys_api',
        host: 'ayxx4u6jpi.execute-api.us-east-1.amazonaws.com',
        endpoint: 'https://ayxx4u6jpi.execute-api.us-east-1.amazonaws.com',
        path: '/{stage}/surveys',
        protocol: 'https',
        methods: ['GET', 'POST'],
        url: 'https://ayxx4u6jpi.execute-api.us-east-1.amazonaws.com/{stage}/surveys'
      },
      {
        name: 'responses_api',
        host: 'ayxx4u6jpi.execute-api.us-east-1.amazonaws.com',
        endpoint: 'https://ayxx4u6jpi.execute-api.us-east-1.amazonaws.com',
        path: '/{stage}/surveys/responses',
        protocol: 'https',
        methods: ['GET'],
        url: 'https://ayxx4u6jpi.execute-api.us-east-1.amazonaws.com/{stage}/surveys/responses'
      },
      {
        name: 'single_survey_api',
        host: 'ayxx4u6jpi.execute-api.us-east-1.amazonaws.com',
        endpoint: 'https://ayxx4u6jpi.execute-api.us-east-1.amazonaws.com',
        path: '/{stage}/surveys/{survey_id}',
        protocol: 'https',
        methods: ['GET'],
        url: 'https://ayxx4u6jpi.execute-api.us-east-1.amazonaws.com/{stage}/surveys/{survey_id}'
      },
      {
        name: 'campaign_deliveries_api',
        endpoint: 'https://37w7ggv8pa.execute-api.us-east-1.amazonaws.com',
        path: '/{stage}/deliveries',
        protocol: 'https',
        methods: ['GET'],
        url: 'https://37w7ggv8pa.execute-api.us-east-1.amazonaws.com/{stage}/deliveries'
      },
      {
        name: 'jobs_api',
        endpoint: 'https://mk1aa8k7il.execute-api.us-east-1.amazonaws.com',
        path: '/{stage}/jobs/',
        protocol: 'https',
        methods: ['GET'],
        url: 'https://mk1aa8k7il.execute-api.us-east-1.amazonaws.com/{stage}/jobs'
      },
      {
        name: 'single_jobs_api',
        endpoint: 'https://mk1aa8k7il.execute-api.us-east-1.amazonaws.com',
        path: '/{stage}/jobs/{job_id}',
        protocol: 'https',
        methods: ['GET', 'DELETE'],
        url: 'https://mk1aa8k7il.execute-api.us-east-1.amazonaws.com/{stage}/jobs/{job_id}'
      },
      {
        name: 'campaign_job_api_start',
        endpoint: 'https://mk1aa8k7il.execute-api.us-east-1.amazonaws.com',
        path: '/{stage}/jobs/campaigns/{campaign_id}',
        protocol: 'https',
        methods: ['POST'],
        url: 'https://mk1aa8k7il.execute-api.us-east-1.amazonaws.com/{stage}/jobs/campaigns/{campaign_id}'
      },
      {
        name: 'insight_job_api_start',
        endpoint: 'https://mk1aa8k7il.execute-api.us-east-1.amazonaws.com',
        path: '/{stage}/jobs/insights/{insight_id}',
        protocol: 'https',
        methods: ['POST'],
        url: 'https://mk1aa8k7il.execute-api.us-east-1.amazonaws.com/{stage}/jobs/insights/{insight_id} '
      },
      {
        name: 'web_socket',
        endpoint: 'wss://gxgp3c9uya.execute-api.us-east-1.amazonaws.com/prod'
      },
      {
        name: 'get-failed-jobs',
        endpoint: 'https://mk1aa8k7il.execute-api.us-east-1.amazonaws.com',
        path: '/{stage}/jobs/get-failed-jobs',
        protocol: 'https',
        methods: ['GET'],
        url: 'https://mk1aa8k7il.execute-api.us-east-1.amazonaws.com/{stage}/jobs/get-failed-jobs '
      },
      {
        name: 'robot_family_metadata_api',
        endpoint: 'https://nz25z0enxl.execute-api.us-east-1.amazonaws.com',
        path: '/{stage}/',
        protocol: 'https',
        methods: ['GET', 'POST', 'PUT'],
        url: 'https://nz25z0enxl.execute-api.us-east-1.amazonaws.com/{stage}/'
      },
      {
        name: 'single_robot_family_metadata_api',
        endpoint: 'https://nz25z0enxl.execute-api.us-east-1.amazonaws.com',
        path: '/{stage}/{robot_family}',
        protocol: 'https',
        methods: ['DELETE'],
        url: 'https://nz25z0enxl.execute-api.us-east-1.amazonaws.com/{stage}/{robot_family}'
      },
      {
        name: 'drb_api',
        endpoint: 'https://52l40fo2xl.execute-api.us-east-1.amazonaws.com',
        path: '/{stage}',
        protocol: 'https',
        methods: ['GET', 'POST', 'PUT'],
        url: 'https://52l40fo2xl.execute-api.us-east-1.amazonaws.com/{stage}/'
      },
      {
        name: 'maps_api',
        endpoint: 'https://2vyeebb0i7.execute-api.us-east-1.amazonaws.com',
        path: '/{stage}/',
        protocol: 'https',
        methods: ['GET'],
        url: 'https://2vyeebb0i7.execute-api.us-east-1.amazonaws.com/{stage}/'
      }
    ]
  },
  oauth: {
    domain: 'insight-engine-prod.auth.us-east-1.amazoncognito.com',
    scope: ['email', 'openid', 'profile'],
    redirectSignIn: 'https://engine.app.insights-prod.data.irobotapi.com/callback',
    redirectSignOut: 'https://engine.app.insights-prod.data.irobotapi.com/signout',
    responseType: 'code'
  },
  federationTarget: 'COGNITO_USER_POOLS'
};

export const CONFIGv6 = {
  Auth: {
    Cognito: {
      userPoolId: CONFIG.aws_user_pools_id,
      userPoolClientId: CONFIG.aws_user_pools_web_client_id,
      identityPoolId: CONFIG.aws_cognito_identity_pool_id,

      loginWith: {
        oauth: {
          domain: CONFIG.oauth.domain,
          scopes: CONFIG.oauth.scope,
          redirectSignIn: [CONFIG.oauth.redirectSignIn],
          redirectSignOut: [CONFIG.oauth.redirectSignOut],
          responseType: CONFIG.oauth.responseType as 'code'
        }
      }
    }
  },

  API: {
    REST: CONFIG.API.endpoints.reduce(
      (acc, endpoint) => ({
        ...acc,
        [endpoint.name]: {
          endpoint: endpoint.endpoint
        }
      }),
      {}
    )
  }
};
